import {Component, AfterViewInit, ViewChild, OnInit, Inject} from '@angular/core';
import { SharedServiceService } from 'app/services/shared-service.service';
import {ResolveEnd, Router, RouterEvent} from '@angular/router';
import { SnackBarComponent} from '@vendor/shared-component/snack-bar/snack-bar.component';
import { ResizedEvent } from 'angular-resize-event';
import {filter} from 'rxjs/operators';
import {AppState} from './app.state';
import {Store} from '@ngrx/store';
declare var $: any;
import * as RouteStackAction from './store/actions/route-stack.action';
import {SwUpdate} from '@angular/service-worker';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DOCUMENT } from '@angular/common';
import {UpdateService} from "./services/update-service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
  clearing: any;
  title = 'hamrah novin';
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  isDesktop = false;
  isStandAlone = true;
  @ViewChild(SnackBarComponent) snackBar: SnackBarComponent;
  constructor(
    private sharedService: SharedServiceService,
    public router: Router,
    private store: Store<AppState>,
    private swUpdate: SwUpdate,
    private idle: Idle, private keepalive: Keepalive,
    @Inject(DOCUMENT) private document: Document,
    private deviceService: DeviceDetectorService,
    private sw: UpdateService
  ) {
    this.idleSetting();
    window.onpopstate = () => {
      if ($('.modal:visible').length && $('body').hasClass('modal-open')) {
        $('.modal').modal('hide');
        return;
      }
      this.unhandledRoute();
    };

    router.events.pipe(
      filter(e => e instanceof RouterEvent)
    ).subscribe(e => {
      if (e instanceof ResolveEnd) {
        setTimeout( x => {
          this.sharedService.handleInputFocus();
          this.sharedService.mainareaHeight();
          }, 100);
      }
    });
    if (swUpdate.isEnabled) {
      swUpdate.available.subscribe(() => {
        swUpdate.activateUpdate().then(() => {
          document.location.reload();
        });
      });
    }
  }

  ngOnInit() {
    // if (this.swUpdate.isEnabled) {
    //   this.swUpdate.available.subscribe(() => {
    //     // document.getElementById('openModalButton').click();
    //   });
    // }
    this.sw.checkForUpdates();
    this.checkDevice();
    // check landscape
    this.isLandscape();
    const supportsOrientationChange = 'onorientationchange' in window;
    const orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';
    window.addEventListener(orientationEvent, () => {
      this.isLandscape();
    }, false);
    this.checkStandalone();
  }
  checkStandalone() {
    this.isStandAlone = !window.matchMedia('(display-mode: standalone)').matches;
  }
  checkDevice() {
    const isDesktopDevice = this.deviceService.isDesktop();
    if (isDesktopDevice) {
      // this.document.location.href = 'https://www.enbank.ir/';
      this.isDesktop = true;
    } else {
      this.isDesktop = false;
    }
  }
  isLandscape() {
    const object = window.screen.orientation || null;
    if (object) {
      if (object.type.indexOf('landscape') !== -1) {
        this.sharedService.setOnorientationchange(true);
        return;
      }
      if (object.type.indexOf('portrait') !== -1) {
        this.sharedService.setOnorientationchange(false);
        return;
      }
    }
    if ('orientation' in window) {
      const value = window.orientation;
      if (value === 0 || value === 180) {
        this.sharedService.setOnorientationchange(false);
        return;
      } else if (value === 90 || value === -90 || value === 270) {
        this.sharedService.setOnorientationchange(true);
        return;
      }
    }
    // fallback to comparing width to height
    if (window.innerWidth > window.innerHeight) {
      this.sharedService.setOnorientationchange(true);
      return;
    }
  }

  reloadPage() {
    window.location.reload();
  }

  ngAfterViewInit() {
    this.sharedService.notification.subscribe(notif => {
      if (notif) {
        this.pushSnackMessage(notif);
      }
    });
  }
  pushSnackMessage(notif) {
    this.snackBar.addSnack(notif.message, notif.success);
  }
  onResized(event: ResizedEvent): void {
    this.checkDevice();
    if (this.isStandAlone) {
      this.sharedService.mainareaHeight();
      this.sharedService.handlePopupBottom();
      $('html,body').stop(true, false).animate({
        scrollTop: 0
      }, 100);
    }
  }
  deleteRouteStack() {
    this.store.dispatch(new RouteStackAction.RemoveRoute() );
  }
  unhandledRoute() {
    this.store.dispatch(new RouteStackAction.UnhandledRoute() );
  }
  idleSetting() {
    // sets an idle timeout of 10 min, for testing purposes.
    this.idle.setIdle(600);
    // sets a timeout period of 10 min. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(600);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      console.log(this.idleState);
      this.reset();
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      sessionStorage.clear();
      localStorage.removeItem('curretToken');
      localStorage.setItem('currentToken', localStorage.getItem('mobileUserToken'));
      window.location.reload();
    });
    // sets the ping interval to 15 seconds
    this.keepalive.interval(660);

    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}
